<template>
    <el-dialog :title="$t('customProduct.PaymentRecords')" width="70vw" :visible.sync="dialogTableVisible" @close="close">
        <el-table :data="gridData">
            <el-table-column :label="$t('customProduct.CreatedTime')">
              <template slot-scope="scope">
                {{ scope.row.createDate | timeToString}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customProduct.TransactionTime')">
              <template slot-scope="scope">
                {{ scope.row.paymentDate | timeToString}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customProduct.Amount')">
              <template slot-scope="scope">
                US${{ scope.row.sampleFee | numberKeepTwoDecimal}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customProduct.Status')">
              <template slot-scope="scope">
                {{ SampleFeePoint[scope.row.paymentStatus]}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('customProduct.Remark')">
              <template slot-scope="scope">
                {{ scope.row.remark }}
              </template>
            </el-table-column>
            <el-table-column label="kakaOrder">
              <template slot-scope="scope">
                <el-link type="primary" @click="jumpOrder(scope.row.kkOrderId)">{{ scope.row.kkOrderId }}</el-link>
              </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      gridData: [],
      dialogTableVisible: false
    }
  },
  computed: {
    SampleFeePoint() {
      const obj = {
        0: '-',
        1: this.$t('customProduct.Unpaid'),
        2: this.$t('customProduct.Paid'),
        3: 'Canceled'
      }
      return obj
    }
  },
  methods: {
    async show(row) {
      try {
        let res = await API.customProductGetPaymentLogList({ demandNo: row.demandNo })
        this.gridData = res.data
      } catch (error) {
        console.log(error)
      }
      this.dialogTableVisible = true
    },
    close() {
      this.gridData = []
      this.dialogTableVisible = false
    },
    jumpOrder(id) {
      this.$router.push({
        path: '/order/details',
        query: {
          kkOrderId: id
        }
      })
    }
  }
}
</script>
